module.exports = __webpack_public_path__ + "static/img/-L6gvfOBnH-pEtb7RZZK.a68e631.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/-L6gvfOBnH-pEtb7RZZK.jpg
// module id = YTzx
// module chunks = 1